import { UPDATE_FIELD } from '../actions/listingform_actions';

const initialState = {
  user_id: '',
  lat: '',
  lng: '',
  name: '',
  description: '',
  guests: '',
  beds: '',
  price: '',
  address: '',
  kind: '',
  city: '',
  country: '',
  image: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FIELD: {
      return {
        ...state,
        [action.field]: action.value,
      };
    }
    default:
      return state;
  }
};

export default reducer;
